import React from 'react';

export const modalMap = {
  Contact: React.Component,
  RateTool: React.Component,
  YourSign: React.Component,
  Language: React.Component,
  CompanyModal: React.Component,
  ChangePassword: React.Component,
  DeleteAccount: React.Component,
  ProfileModal: React.Component,
  AddUserModal: React.Component,
  CancelSubscription: React.Component,
  UpgradeAnnual: React.Component,
  EsignDeletionQuestion: React.Component,
  PremiumModal: React.Component,
  EditEmailModal: React.Component,
  Rename: React.Component,
  MakeSure: React.Component,
  DownloadSignup: React.Component,
  DownloadVerificationCode: React.Component,
  DownloadLogin: React.Component,
  PlanSelection: React.Component,
  PaddlePayment: React.Component,
  Paywall1: React.Component,
  Paywall2: React.Component,
  Paywall3: React.Component,
  DownloadSuccess: React.Component,
  EditShare: React.Component,
  EditProcessAnimation: React.Component,
  ProtectPdfPassword: React.Component,
  ProtectPdfCurrentPassword: React.Component,
  ProtectPdfProtected: React.Component,
  UnlockPdfProcessing: React.Component,
  ReviewFlow: React.Component,
  FallbackProgress: React.Component,
  ProceedPopup: React.Component,
};
